/**
 * CompanyMembersViewElement — kreator formatek: klocek palety reprezentujący
 * widget "Uzytkownicy firmy" (`company_members_view`, patrz `RecursiveFormRenderer`
 * PLACEHOLDER_TYPES).
 *
 * Mirror `AuditLogViewElement` (patrz jego nagłówek) — na REALNEJ stronie rekordu
 * ten typ jest dispatchowany WYŁĄCZNIE przez `contextRenderers['company_members_view']`
 * (widget `CompanyMembersSection`, patrz `pages/company-context-renderers.tsx`). Ten
 * plik obsługuje TYLKO podgląd w canvasie buildera (`mode='builder'`), gdzie nie ma
 * prawdziwego rekordu (companyId).
 *
 * PO CO: dotąd jedynym sposobem pokazania na karcie firmy tego, kto ma do niej dostęp,
 * była karta USERA (`Dostępy do firm`) — zarządzanie z poziomu firmy wymagałoby kolejnej
 * zaszytej na sztywno zakładki (jak `Konta bankowe`/`Działy`). Ten klocek daje to samo
 * jako element silnika layoutu: admin dodaje/usuwa go z konkretnej karty firmy bez
 * udziału developera, dane pod spodem (`user_company_access`) są nietknięte niezależnie
 * od tego, czy element jest akurat na layoucie.
 *
 * `allowedModules` — WYŁĄCZNIE `companies`. Firma jest jedyną kartoteką, której strona
 * detalu dispatchuje ten typ przez `contextRenderers` (wpięcie — patrz `CompanyDetail.tsx`
 * + `CompanyDataTab.tsx`). Element bez `propertiesEditor` — `companyId` pochodzi z
 * rekordu (kontekst renderera), nie z `settings` (brak konfiguracji per-placement).
 *
 * `render` jest wołany jak ZWYKŁA FUNKCJA (nie komponent) — żaden hook nie może być
 * wywołany BEZPOŚREDNIO w jej ciele: `i18n.t` standalone zamiast `useTranslation`.
 *
 * `label` jest literalnym stringiem, zgodnie z precedensem reszty palety.
 */

import { Users } from 'lucide-react';

import type { LayoutElementDefinition } from '@/components/fields/LayoutElementRegistry';
import i18n from '@/i18n';

/** Kartoteki, których strona detalu dispatchuje `company_members_view` przez `contextRenderers`. */
const COMPANY_MEMBERS_VIEW_ALLOWED_MODULES = ['companies'];

export const CompanyMembersViewElement: LayoutElementDefinition = {
  type: 'company_members_view',
  category: 'tresc',
  isContainer: false,
  label: 'Użytkownicy firmy',
  icon: 'Users',
  allowedModules: COMPANY_MEMBERS_VIEW_ALLOWED_MODULES,
  defaultSettings: () => ({}),
  render: ({ element }) => (
    <div
      className="rounded-lg border border-dashed border-border-secondary bg-bg-secondary p-4 text-center"
      data-testid={`company-members-view-element-${element.id}`}
      data-element-type="company_members_view"
    >
      <Users className="mx-auto h-5 w-5 text-text-muted" aria-hidden="true" />
      <p className="mt-1 text-xs font-medium text-text-secondary">
        {i18n.t('tenant.companies.members.paletteLabel', { defaultValue: 'Użytkownicy firmy' })}
      </p>
    </div>
  ),
};
